
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/news",
      function () {
        return require("private-next-pages/[athleteSlug]/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/news"])
      });
    }
  